import { useTranslation } from "react-i18next";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { textStyles } from "@/lib/textStyles";

interface Props {
  value: string;
  onChange: (val: string) => void;
}

export const MembersTabs = ({ value, onChange }: Props) => {
  const { t } = useTranslation("membersGroups");
  const getTriggerStyle = (tabValue: string) => ({
    ...textStyles.body,
    ...(value === tabValue
      ? { color: "var(--primary)", fontWeight: 700 }
      : {}),
  });

  return (
    <Tabs value={value} onValueChange={onChange}>
      <TabsList variant="line" className="flex justify-start gap-6 p-0 h-auto">
        <TabsTrigger
          value="members"
          style={getTriggerStyle("members")}
          className="px-0 pb-0
  data-[state=active]:text-primary
  data-[state=active]:after:bg-primary
  rounded-none cursor-pointer"
        >
          {t("tabs.members")}
        </TabsTrigger>

        <TabsTrigger
          value="groups"
          style={getTriggerStyle("groups")}
          className="px-0 pb-0
  data-[state=active]:text-primary
  data-[state=active]:after:bg-primary
  rounded-none cursor-pointer"
        >
          {t("tabs.groups")}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};
